import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  &&& {
    color: #000;
    text-align: center;
  }

  h1 {
    font-size: 32px;
    font-weight: bold;
  }

  h4 {
    font-size: 15px;
  }
`;

const TextArea = ({ className, children }) => {
  return (
    <StyledDiv className={className}>
      <div>{children}</div>
    </StyledDiv>
  );
};

export default TextArea;
